// TODO update this to import from commons
// import { gql } from '@reverbdotcom/commons/src/gql';
// eslint-disable-next-line no-restricted-imports
import { gql } from '@apollo/client';
import React from 'react';
import I18n from 'i18n-js';
import { RCButton, RCTextWithIcon } from '@reverbdotcom/cadence/components';
import { CoreProductReviewVote } from '@reverbdotcom/commons/src/gql/graphql';
import { MParticleEventName, trackEvent } from '@reverbdotcom/commons/src/elog/mparticle_tracker';
import { ProductReviewInteraction } from '@reverbdotcom/commons/src/elog/mparticle_types';
import { ThumbsUpIcon } from '@reverbdotcom/cadence/icons/react';
import { useMutation } from '@reverbdotcom/commons/src/useMutation';

interface Props {
  reviewId: string;
  cspId: string;
  trackingDisplayStyle: 'product' | 'csp';
  disabled?: boolean;
}

export function ProductReviewVoteButton(props: Props) {
  const [mutate, { loading }] = useMutation<
    CoreProductReviewVote.Mutation,
    CoreProductReviewVote.Variables
  >(
    VOTE_PRODUCT_REVIEW_MUTATION,
  );

  async function onProductReviewVote() {
    await mutate({
      variables: {
        id: props.reviewId,
      },
      refetchQueries: ['Core_Product_Reviews'],
      awaitRefetchQueries: true,
    });

    trackEvent({
      eventName: MParticleEventName.ProductReviewAction,
      productReviewInteraction: ProductReviewInteraction.VoteReview,
      displayStyle: props.trackingDisplayStyle,
      cspId: props.cspId,
      productReviewId: props.reviewId,
    });
  }

  return (
    <RCButton
      size="mini"
      variant="muted"
      disabled={loading || props.disabled}
      onClick={onProductReviewVote}
    >
      <RCTextWithIcon
        svgComponent={ThumbsUpIcon}
        placement="left"
      >
        {I18n.t('discovery.productReviews.voteButton.helpful')}
      </RCTextWithIcon>
    </RCButton>
  );
}

const VOTE_PRODUCT_REVIEW_MUTATION = gql`
  mutation Core_ProductReview_Vote($id: String) {
    voteProductReview(input: { id: $id }) {
      id
    }
  }
`;
